import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { financeApplicationsApi } from '@/lib/api/finance-applications.api';

import type { FinanceApplicationQuery } from '@repo/shared-types';

const QUERY_KEY = ['finance-applications'];

export const useFinanceApplications = (query: Partial<FinanceApplicationQuery> = {}) =>
  useQuery({
    queryKey: [...QUERY_KEY, query],
    queryFn: () => financeApplicationsApi.getAll(query),
  });

export const useFinanceApplication = (id: string | undefined) =>
  useQuery({
    queryKey: [...QUERY_KEY, id],
    queryFn: () => financeApplicationsApi.getOne(id!),
    enabled: !!id,
  });

export const useFinanceApplicationsByCall = (callId: string | undefined) =>
  useQuery({
    queryKey: [...QUERY_KEY, 'by-call', callId],
    queryFn: () => financeApplicationsApi.getByCall(callId!),
    enabled: !!callId,
  });

export const useDeleteFinanceApplication = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => financeApplicationsApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  });
};
